import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { map, tap } from 'rxjs/operators';

export interface LinksResponse {
  resources: Array<{
    files: Array<any>,
    miniature: string,
    name: string,
    model: string,
    position: {
      rotation: Array<number>,
      scale: Array<number>,
      translation: Array<number>
    },
  }>;
}
@Injectable({ providedIn: 'root' })
export class TasksService {

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  getMiniature(modelID: string) {
    return this.http.get(`${environment.url}/model/${modelID}/miniature`, { responseType: 'blob' })
      .pipe(
        map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val)))
      );
  }

  LoadModel(modelID: string): Observable<any> {
    // console.log(`${environment.url}/model/${modelID}`);
    return this.http.get(`${environment.url}/model/${modelID}`, {
      headers: new HttpHeaders({
        //   'Accept-Encoding': 'identity',
        'Compression': 'none'
      }),
      responseType: 'json',
      reportProgress: true,
      observe: 'events',
    });
  }
}
